<template>
    <div v-if="loading" class="flex min-h-[70vh] items-center justify-center"><Loader /></div>
    <div v-else class="ds-employees-page-tabs">
        <div class="ds-employees-page ds-app-shell">
            <EmployeesList ref="employeesList" @user-click="onUserClick" @create="openUserCreatePanel" />
        </div>
        <SidePanel ref="usercard">
            <EmployeeDossier
                v-if="employmentStore.user"
                :key="employmentStore.user.id"
                context="employees"
                :archive="isArchive"
                :user="employmentStore.user"
                @updated="onDossierUpdated"
            />
        </SidePanel>

        <SidePanel ref="usercreate">
            <CreateUser @close="openUserCreatePanel" @created="onUserCreated"/>
        </SidePanel>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import EmployeesList from '@/components/employees/EmployeesList.vue'
import SidePanel from '@/components/schedule/SidePanel.vue'
import EmployeeDossier from '@/components/dossier/EmployeeDossier.vue'
import Loader from '@/ui/Loader.vue'
import CreateUser from '@/components/employees/CreateUser.vue'
import { useDepartmentStore } from '@/stores/departmentStore'
import { useEmploymentStore } from '@/stores/employmentStore'
import { useAuthStore } from '@/stores/authStore'
import { useToast } from 'vue-toast-notification'
import type { EmployeeRow } from '@/components/employees/employeesList'

const toast = useToast({ position: 'bottom-right' })

const departmentStore = useDepartmentStore()
const employmentStore = useEmploymentStore()
const authStore = useAuthStore()

const loading = ref(true)
const isArchive = ref(false)

const usercard = ref()
const usercreate = ref()
const employeesList = ref<InstanceType<typeof EmployeesList> | null>(null)

const openUserPanel = () => {
    usercard.value.toggle()
}

const openUserCreatePanel = () => {
     if(authStore.permissions?.can_create_user) {
        usercreate.value.toggle()
    } else {
        toast.error('У вас нет прав на данное действие')
    }
}

// Досье открывается по локальной записи списка (шапка сразу), GET User актуализирует данные.
// employmentStore.user — прежний контракт открытия карточки (RD-153), из него досье берёт исходную запись.
const onUserClick = (data: { employee: EmployeeRow, archive: boolean }) => {
    openUserPanel()
    employmentStore.user = data.employee
    isArchive.value = data.archive
}

// Подтверждённая запись в досье (RD-149): досье остаётся открытым, список перезагружается
// без сброса поиска, фильтров и страницы.
const onDossierUpdated = () => {
    employeesList.value?.reload()
}

const onUserCreated = () => {
    openUserCreatePanel()
}

const init = async () => {
    loading.value = true
    await departmentStore.fetchMyDepartments()
    loading.value = false
}

onMounted(() => {
    init()
})
</script>
